module.exports = __webpack_public_path__ + "static/media/user.76c62425.png";